import { useState } from 'preact/hooks'
import { useSearchspringContext } from 'libs/searchspring/fetchers/provider'
import { useBeaconLogImpressions, useBeaconLogRender } from 'libs/searchspring/hooks/useBeaconAnalytics'
import { ResultsCard } from 'libs/searchspring/components/ResultCard'
import { SkeletonCard } from 'libs/searchspring/components/SkeletonCard'
import clsx from 'clsx'

export function BaseResults({ className, wrapperClassName = '', containerClassName = 'flex relative w-full', productCardSettings, renderWrapper, placeholderCount: placeholderCountProp }) {
  const { results, isLoading } = useSearchspringContext()
  const [node, setNode] = useState()

  useBeaconLogRender()
  useBeaconLogImpressions(node)

  if (results?.results?.length === 0 && !isLoading) return null

  const placeholderCount = results?.results?.length || placeholderCountProp || 8
  const items = Array.from({ length: placeholderCount }, (_, index) => ({
    id: index,
    result: results?.results?.[index]
  }))

  const renderSkeletonItems = () => items.map((_, index) => (
    <div className={clsx(className, 'shrink-0')} key={`skeleton-${index}`}>
      <SkeletonCard {...(productCardSettings && { options: productCardSettings })} />
    </div>
  ))

  const renderRealItems = () => items.map(({ id, result }) => (
    <div className={clsx(className, 'shrink-0')} key={result?.handle || id}>
      {result && (
        <ResultsCard
          result={result}
          className="wk-wishlist-button-target"
          dataIndex={id.toString()}
          {...(productCardSettings && { options: productCardSettings })}
        />
      )}
    </div>
  ))

  const renderGridItems = () => items.map(({ id, result }) => (
    <div className={clsx(className, 'shrink-0')} key={result?.handle || id}>
      {result ? (
        <ResultsCard
          result={result}
          className="wk-wishlist-button-target"
          dataIndex={id.toString()}
          {...(productCardSettings && { options: productCardSettings })}
        />
      ) : (
        <SkeletonCard {...(productCardSettings && { options: productCardSettings })} />
      )}
    </div>
  ))

  return (
    <div ref={setNode} className={clsx(containerClassName, wrapperClassName)}>
      {renderWrapper ? renderWrapper(renderSkeletonItems(), renderRealItems()) : renderGridItems()}
    </div>
  )
}
